// src/App.tsx
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import SignIn from './pages/SignIn';
import SignUp from './pages/SignUp';
import AnalysePage from './pages/Analyse';
import AdminPage from './pages/AdminPage';
import HistoryPage from './pages/History';
import BillingPage from './pages/Billing';
import BillingHistoryPage from './pages/BillingHistory';  // Add this import

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/signin" element={<SignIn />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/analyse" element={<AnalysePage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/history" element={<HistoryPage />} />
        <Route path="/billing" element={<BillingPage />} />
        <Route path="/billing-history" element={<BillingHistoryPage />} />  {/* Add this new route */}
        {/* Redirect unknown routes to Sign In */}
        <Route path="*" element={<Navigate to="/signin" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
